// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"d72e76e6","299":"12099bd2","329":"cfd5eb5b","417":"36fc4b8b","517":"1860f119","572":"c66a2f87","574":"18a8423e","626":"5700c9cf","661":"21f789ad","825":"f1105258","909":"9670ed1d","956":"408b93d0","984":"17b67b47"}[chunkId] + ".chunk.js";
};